import React from 'react'
import Loader from '../../assets/svg/loading.svg'
import styles from './styles.css'
import ReactModal from 'react-modal'

ReactModal.setAppElement('#main');

function getParent() {
  return document.querySelector('#main');
}

const Loading = props => (
  <ReactModal 
    isOpen={props.isOpen}
    className={styles.modal}
    overlayClassName={styles.overlay}
    parentSelector={getParent}
  >
    <img src={Loader} alt="" className={styles.loader} />
  </ReactModal>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js